// Load initial locale from localStorage, fallback to 'nl'
const getInitialLocale = () => {
  try {
    const savedLocale = localStorage.getItem('aircheckr_locale');
    return savedLocale || 'nl';
  } catch (error) {
    console.error('Error loading locale from localStorage:', error);
    return 'nl';
  }
};

const locale = (state = {
  value: getInitialLocale(),
  hasTranslation: false,
}, action) => {
  switch(action.type) {
    case 'UPDATE_LOCALE':
      // Save locale to localStorage
      try {
        localStorage.setItem('aircheckr_locale', action.locale);
      } catch (error) {
        console.error('Error saving locale to localStorage:', error);
      }
      return Object.assign({}, state, { value: action.locale, hasTranslation: action.hasTranslation });
    default:
      return state;
  }
};

export default locale;



// WEBPACK FOOTER //
// ./src/reducers/locale/locale.js